import { SxProps, Theme } from '@mui/material';
import {
  cssColorPrimary,
  cssColorDark,
  cssColorSuccess,
  cssColorWarning,
  cssColorError,
  cssColorLight,
} from './globalcss';

export const buttonSizeMap = {
  large: {
    fontSize: '1rem',
    padding: '10px 30px',
  },
  medium: {
    fontSize: '0.9rem',
    padding: '8px 20px',
  },
  small: {
    fontSize: '0.875rem',
    padding: '6px 16px',
  },
};

export const primaryButtonStyle: SxProps<Theme> = {
  '&:active': {
    backgroundColor: cssColorDark, // Use dark background color for active state
    boxShadow: 'none',
  },
  '&:hover': {
    backgroundColor: cssColorLight, // Use secondary color for hover
    boxShadow: '0 4px 8px rgba(0,0,0,0.15)',
  },

  backgroundColor: cssColorPrimary,

  boxShadow: '0 2px 4px rgba(0,0,0,0.1)',

  // Use primary color constant
  color: 'white',
  // Light text for better contrast on dark background
  fontWeight: 600,
};

export const secondaryButtonStyle: SxProps<Theme> = {
  '&:active': {
    backgroundColor: `${cssColorPrimary}20`, // 20% opacity primary color
    borderColor: cssColorPrimary,
  },
  '&:hover': {
    backgroundColor: `${cssColorPrimary}10`, // 10% opacity primary color
    borderColor: cssColorPrimary,
  },
  borderColor: cssColorPrimary,
  color: cssColorPrimary,
  fontWeight: 600,
};

// New darker secondary style for menu items and back buttons
export const darkSecondaryButtonStyle: SxProps<Theme> = {
  '&:hover': {
    backgroundColor: cssColorPrimary,
    borderColor: cssColorPrimary,
    color: 'white',
  },
  borderColor: cssColorPrimary,
  color: cssColorPrimary,
  fontWeight: 600,
};

// Success button style
export const successButtonStyle: SxProps<Theme> = {
  '&:hover': {
    backgroundColor: '#3d8b40', // Darker shade of success color
  },
  backgroundColor: cssColorSuccess,
  color: 'white',
  fontWeight: 600,
};

// Warning button style
export const warningButtonStyle: SxProps<Theme> = {
  '&:hover': {
    backgroundColor: '#e68900', // Darker shade of warning color
  },
  backgroundColor: cssColorWarning,
  color: 'white',
  fontWeight: 600,
};

// Error button style
export const errorButtonStyle: SxProps<Theme> = {
  '&:hover': {
    backgroundColor: '#b71c1c', // Darker shade of error color
  },
  backgroundColor: cssColorError,
  color: 'white',
  fontWeight: 600,
};
